"use client";

import { useEffect, useState } from "react";

import { REDUCED_MOTION_QUERY } from "@demo/utils/media-set-motion";

/** Track the OS reduced-motion preference, including changes while the app is open. */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const query = window.matchMedia(REDUCED_MOTION_QUERY);
    const update = () => setReduced(query.matches);
    update();
    query.addEventListener?.("change", update);
    return () => query.removeEventListener?.("change", update);
  }, []);

  return reduced;
}
